import React, { useCallback } from 'react'
import { Button, ButtonProps, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import { useHistory } from 'react-router-dom'
import { Colors } from '../../../theme'

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    width: ({ width }: propTypes) => width,
    marginTop: ({ mt }: propTypes) => mt,
    marginBottom: ({ mb }: propTypes) => mb,
    marginLeft: ({ ml }: propTypes) => ml,
    marginRight: ({ mr }: propTypes) => mr,

    height: 40,
    padding: '10px 0',

    borderRadius: 4,

    fontSize: 14,
    fontWeight: 500,
    lineHeight: 0,

    color: theme.palette.primary.light,
    background: Colors.darkGrey,
    borderColor: theme.palette.primary.light,
    '&:hover': {
      color: theme.palette.primary.light,
      background: Colors.darkGrey,
      borderColor: theme.palette.secondary.main,
    },
  },
  prefix: {
    fontSize: 18,
    fontWeight: 400,
    paddingRight: 10,
    lineHeight: 0,
  },
  text: {
    textTransform: 'none',
  },
}))

type propTypes = Omit<ButtonProps, 'type'> & {
  prefix?: string
  text: string
  width: number | string
  mt?: number | string
  mb?: number | string
  ml?: number | string
  mr?: number | string
  // eslint-disable-next-line
  type?: string | any
  href?: string
  disabled?: boolean
  onClick?: () => void | undefined
}

export const OutlinedButton: React.FC<propTypes> = ({
  prefix,
  text,
  width,
  mt,
  mb,
  ml,
  mr,
  type,
  href,
  disabled,
  onClick,
  ...props
}) => {
  const classes = useStyles({ prefix, text, width, mt, mb, ml, mr, type, href })
  const history = useHistory()

  const goTo = useCallback(() => {
    history.push(`${href}`)
  }, [history, href])

  return (
    <Button
      disabled={disabled}
      variant="outlined"
      type={type || 'submit'}
      className={classes.button}
      onClick={href ? goTo : onClick}
      {...props}
    >
      {prefix && <span className={clsx(classes.prefix, 'material-icons')}>{prefix}</span>}
      <span className={classes.text}>{text}</span>
    </Button>
  )
}
